import { mapActions, mapGetters } from 'vuex';
import queryString from 'query-string';

export default {
  name  : 'ChooseCorrectionModal',
  props : {
    isOpen: {
      type    : Boolean,
      default : false
    },
    questionCollectionExternalId: {
      type     : String,
      required : true,
      default  : ''
    },
    academicMainExternalId: {
      type     : String,
      required : true,
      default  : ''
    }
  },
  data() {
    return {
      isLoading        : false,
      correctionChosen : 'student'
    };
  },
  computed: {
    ...mapGetters({
      getterUserRoleContext: 'plataforma/user/getterUserContext'
    })
  },
  methods: {
    ...mapActions({
      actionSSOUrl: '_core/auth/actionSSOUrl'
    }),
    resetModal() {
      this.$emit('close');

      this.correctionChosen = 'student';
      this.removeExtraScrollBar();
    },
    getSSOUrl() {
      this.isLoading = true;
      this.$nuxt.$loading.start();

      const queryParams = {
        destinationPage              : 'corrections',
        correctionType               : this.correctionChosen,
        questionCollectionExternalId : this.questionCollectionExternalId,
        classExternalId              : this.academicMainExternalId
      };

      this.actionSSOUrl(this.getterUserRoleContext.isStudent ? 'avalia-online' : 'avalia-backoffice')
        .then((safeaUrl) => {
          const queryStringFormat = queryString.stringify({ ...queryParams, ...this.$route.query }, { skipNull: true, skipEmptyString: false });
          const urlAvalia = `${safeaUrl}&${queryStringFormat}&returnUrl=/sso`;

          this.$nuxt.$emit('isOpenContentModalAvalia', {
            urlAvalia,
            title: this.$t('content.layout.timeline.modalsContentType.avaliaExternalActivity.externalActivityLabel')
          });

          this.resetModal();
        })
        .catch((error) => {
          this.$toast.error(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.$nuxt.$loading.finish();
        });
    },
    removeExtraScrollBar() {
      this.$nextTick(() => {
        document.documentElement.classList.add('overflow-y-hidden');
      });
    }
  }
};
